import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { forwardRef, useContext, useImperativeHandle, useState } from "react";
import { BaseStepProps } from ".";
import Image from "next/image";
import AstronautLottie from "../../components/AstronautLottie";
import { submit } from "../../services/auth/index-new";
import { BoardingFlowContext } from "../../context/auth/BoardingFlowContext";
import { useFormContext } from "react-hook-form";
import circularProgress from "../../public/assets/lottie/circularProgress.json";
import phoneSocial from "../../public/assets/onboarding/phone_social.svg";
import dynamic from "next/dynamic";
const Lottie = dynamic(() => import("lottie-react-web"), { ssr: false });
import useAppleDevice from "../../hooks/isAppleDevice";
import { Apple, Google } from "../../public/assets";
import { ALREADY_EXIST_EMAIL_LOGIN_CODE } from "../../helpers";
import { IntroContext } from "../../context";
import {
  UserObject,
  getUserInfoById,
  uploadUserInfo,
  useBoardingFlow,
} from "../../hooks/useBoardingFlow";
import parsePhoneNumberFromString from "libphonenumber-js";

export type socialMethod = "google" | "apple";

function IWantToConnectMyStep(props: BaseStepProps, ref) {
  const [tempData] = useContext(BoardingFlowContext).tempData;
  const [, setPhoneRoute] = useContext(BoardingFlowContext).phoneRoute;
  const isAppleDevice = useAppleDevice();
  const [socialProcessStarted, setSocialProcessStarted] =
    useState<socialMethod | null>(null);
  const [, setActiveTab] = useContext(BoardingFlowContext).activeTab;
  const { setValue, setError, formState, getValues, clearErrors } =
    useFormContext();
  const authJourneyRef = useContext(IntroContext).authJourneyRef;
  const { signInWithPhone } = useBoardingFlow();

  useImperativeHandle(ref, () => ({
    reset: () => {
      setSocialProcessStarted(null);
    },
  }));

  const handleOpenRoute = (path) => () => {
    const win = window.open(path, "_blank");
    win.focus();
  };

  const handleSignInWithExistingPhone = async () => {
    console.warn("Sign in with existing phone started - ");
    signInWithPhone({
      phoneNumber: getValues("phoneNumber"),
      setIsPending: () => {},
      handleSuccess: () => {
        console.log("OTP sent successfully, Now setting the active tab to ", 2);
        setSocialProcessStarted(null);
        setActiveTab(2);
      },
      handleError: (errorMessage) => {
        console.log("Error in sending OTP - ", errorMessage);
        setSocialProcessStarted(null);
        setError(
          "email",
          {
            message:
              errorMessage ?? "Something went wrong. Please try again later.",
          },
          { shouldFocus: true }
        );
      },
    });
  };

  const handleConnectWithEmail = (method: socialMethod) => {
    if (socialProcessStarted)
      return setError("email", { message: "One Process has already started" });

    setSocialProcessStarted(method);
    clearErrors();
    submit({
      method,
      provider: require("../../firebase-config")[
        `${method}Provider`
      ] as firebase.auth.AuthProvider,
      tempData,
      handleError: (message: string) => {
        setSocialProcessStarted(null);
        setError("email", { message });
      },
      handleSuccess: (user: UserObject) => {
        setSocialProcessStarted(null);
        authJourneyRef.current.logEvent("pustack_event_has_connected_social");

        // Showing the user a grade screen
        setValue("name", user.name);
        setActiveTab(3);
      },
      handleExistingAccount: async (user: firebase.User) => {
        if (user?.email) {
          setPhoneRoute(false);
          console.log("User has email - ", user.email);
          let userData = await getUserInfoById(user?.uid);
          if (!userData.email || !userData.phone_number) {
            console.log(
              "User Document doesn't have either email or phone number - ",
              userData.email,
              userData.phone_number
            );

            const parsedNumber = parsePhoneNumberFromString(user.phoneNumber);
            userData = await uploadUserInfo({
              userId: user?.uid,
              avatarUrl: user?.photoURL ?? null,
              name: user?.displayName ?? null,
              email: user?.email ?? null,
              phoneNumber: parsedNumber.nationalNumber ?? null,
              countryCode: "+" + parsedNumber.countryCallingCode ?? null,
              isInstructor: false,
            });
            console.log("Upadted the user document - ", {
              userId: user?.uid,
              avatarUrl: user?.photoURL ?? null,
              name: user?.displayName ?? null,
              email: user?.email ?? null,
              phoneNumber: parsedNumber.nationalNumber ?? null,
              countryCode: "+" + parsedNumber.countryCallingCode ?? null,
              isInstructor: false,
            });
          }

          if (userData.phone_number) {
            console.log(
              "User Document has phone number - ",
              userData.phone_number
            );
            setValue(
              "phoneNumber",
              "+" + userData.phone_country_code + userData.phone_number
            );
            console.log("Setting error that the Account already exists - ");
            setError("phoneExists", {
              message: "Account already exists.",
            });
            return handleSignInWithExistingPhone();
          }

          setSocialProcessStarted(null);
          return props.reset();
        }
      },
    });
  };

  return (
    <div className="slide__page">
      <div className="third__page__inner">
        <div className="stars__background">
          <div className="stars" />
          <div className="twinkling" />
        </div>
        <div className="top__area third__page">
          <button
            onClick={() =>
              setTimeout(() => {
                props.reset();
              })
            }
          >
            <ArrowBackIosIcon />
          </button>
          <h6>I want to connect my</h6>
        </div>
        <div className="social__accounts">
          <button
            className="google"
            onClick={() => handleConnectWithEmail("google")}
          >
            <Image
              height={100}
              width={100}
              src={Google}
              draggable={false}
              alt="g"
            />
            <h6>
              CONTINUE WITH GOOGLE{" "}
              {socialProcessStarted === "google" && (
                <Lottie
                  options={{
                    animationData: circularProgress,
                    loop: true,
                  }}
                />
              )}
            </h6>
          </button>
          {/*<button*/}
          {/*  className="facebook"*/}
          {/*  onClick={() => {*/}
          {/*    if (socialProcessStarted.every((item) => item === false)) {*/}
          {/*      setSocialProcessStarted([true, false, false]);*/}
          {/*      submit(*/}
          {/*        require('../firebase-config').facebookProvider,*/}
          {/*        tempPhoneUserData,*/}
          {/*        setPhoneNumberError,*/}
          {/*        setSocialProcessStarted,*/}
          {/*        setExistingAccountError,*/}
          {/*        handleAuth,*/}
          {/*        setData,*/}
          {/*        'facebook',*/}
          {/*        submitGoogleEmailFn*/}
          {/*      ).then();*/}
          {/*    } else {*/}
          {/*      setEmailError("One Process has already started");*/}
          {/*      setTimeout(() => setEmailError(""), 4000);*/}
          {/*    }*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <Image height={100} width={100} src={Facebook} draggable={false} alt="fb" />*/}
          {/*  <h6>*/}
          {/*    CONTINUE WITH FACEBOOK*/}
          {/*    {socialProcessStarted[0] && (*/}
          {/*      <Lottie*/}
          {/*        options={{*/}
          {/*          animationData: circularProgress,*/}
          {/*          loop: true,*/}
          {/*        }}*/}
          {/*      />*/}
          {/*    )}*/}
          {/*  </h6>*/}
          {/*</button>*/}
          {isAppleDevice && (
            <button
              className="apple"
              onClick={() => handleConnectWithEmail("apple")}
            >
              <Image
                height={100}
                width={100}
                src={Apple}
                draggable={false}
                alt="fb"
              />
              <h6>
                CONTINUE WITH APPLE
                {socialProcessStarted === "apple" && (
                  <Lottie
                    options={{
                      animationData: circularProgress,
                      loop: true,
                    }}
                  />
                )}
              </h6>
            </button>
          )}
        </div>
        <div className="astronaut__lottie">
          <AstronautLottie />
        </div>
        <Image
          height={100}
          width={100}
          src={phoneSocial}
          alt="phoneSocial"
          className="phone__social"
        />
        {formState.errors.email && (
          <div className="error__message fadeIn">
            {formState.errors.email.message ===
            ALREADY_EXIST_EMAIL_LOGIN_CODE ? (
              <p>
                Account with the email exists. Want to{" "}
                <span
                  style={{ cursor: "pointer", color: "dodgerblue" }}
                  // onClick={handleLoginAfterEmailExist}
                >
                  Login
                </span>
                ?
              </p>
            ) : (
              (formState.errors.email.message as string)
            )}
          </div>
        )}

        <div className="agreements">
          <h6>By continuing, you agree to our</h6>
          <div>
            <h5 onClick={handleOpenRoute("/terms_of_service")}>
              Terms of Service
            </h5>{" "}
            <h5 onClick={handleOpenRoute("/privacy_policy")}>Privacy Policy</h5>
          </div>
        </div>
      </div>
    </div>
  );
}

export default forwardRef(IWantToConnectMyStep);
